/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Keyboard, TextInput, ScrollView } from 'react-native'
import styles from './Styles/PopUpReportComponentStyle'
import SectionHeader from './SectionHeader'
import SearchBarComponent from './SearchBarComponent'
import TextComponent from './TextComponent'
import { ListItem, Left, Body, Right, Thumbnail } from 'native-base'
import Modal from 'react-native-modalbox';
import { isBlank } from '../Lib/utils'
import I18n from "i18n-js"

export default class PopUpReportComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      isOpen: false,
      comment: '',
      reason: ''
    }
  }
 
  showModal = (reason) => {
    this.setState({
      reason
    }, () => {
      this.refs.modal.open()
    })

  }
  onCancel = () => {
    this.closeModal()
  }
  onReport = (reason, comment) => {
    this.props.onReport(reason, comment)
    this.closeModal()

  }
  closeModal = () => {
    if (this.refs && this.refs.modal) {
      this.refs.modal.close()
    }
  }
  render() {
    const { onReport } = this.props
    const reasonText = `Reason: ` + this.state.reason
    const placeholder = `If necessary, provide addional information...`
    return (

      <Modal

        ref={"modal"}
        style={styles.modal}
        position='center'
        backdrop={true}
        coverScreen={true}
        onClosed={() => {

        }}>

        <View style={styles.header}>
          <View>
            <SectionHeader
              onPress={this.onCancel}
              text={I18n.t('signUp.cancel')}
              style={styles.textButton}
              containerStyle={styles.button} />
          </View>
          <View style={styles.middle}>
            <TextComponent text={`Report post`} style={styles.middleText} />
          </View>
          <View style={styles.right}>
            <SectionHeader
              onPress={() => this.onReport(this.state.reason, this.state.comment)}
              style={styles.textButton}
              text={`Report`}
              containerStyle={styles.button} />
          </View>

        </View>

        <View style={styles.reason}>
          <TextComponent text={reasonText} style={styles.middleText} />
        </View>

        <TextInput

          onChangeText={(text) => this.setState({
            comment: text
          })}
          blurOnSubmit={true}

          editable={true}
          numberOfLines={0}
          multiline={true}
          placeholderTextColor='#d6d2d9'
          placeholder={placeholder}
          style={[styles.textInputStyle]} />

      </Modal>

    )
  }
}
